module.exports = __webpack_public_path__ + "static_pc/img/27.dcf5fb8c.png";